import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

import { absenceEnum, areaEnum } from "../../../config/enum";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fr } from "date-fns/locale";
import moment from "moment";

// Material Dashboard 2 PRO React components
import MDInput from "../../../components/MDInput";
import MDBox from "../../../components/MDBox";

export default function Absence({
  absenceDescription,
  setAbsenceDescription,
  tripArea,
  setTripArea,
  boolAbsenceStartDate,
  setBoolAbsenceStartDate,
  absenceStartDate,
  setAbsenceStartDate,
  boolAbsenceEndDate,
  setBoolAbsenceEndDate,
  absenceEndDate,
  setAbsenceEndDate,
}) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={12} lg={absenceDescription !== "Déplacement" ? 12 : 6}>
          <Autocomplete
            freeSolo
            options={absenceEnum}
            value={absenceDescription}
            required
            onChange={(event, newAbsenceDescription) => {
              if (newAbsenceDescription) {
                setAbsenceDescription(newAbsenceDescription);
              }
            }}
            onInputChange={(event, newInputValue) => {
              setAbsenceDescription(newInputValue);
            }}
            renderInput={(params) => (
              <MDInput {...params} label="Description de l'absence" variant="standard" />
            )}
          />
        </Grid>
        {absenceDescription === "Déplacement" && (
          <Grid item xs={12} lg={6}>
            <Autocomplete
              options={areaEnum}
              value={tripArea}
              required
              onChange={(event, newTripArea) => {
                setTripArea(newTripArea);
              }}
              renderInput={(params) => (
                <MDInput {...params} label="Zone du déplacement" variant="standard" />
              )}
            />
          </Grid>
        )}
        <Grid item container xs={12} spacing={2}>
          <Grid item xs={12} lg={6} display="block" alignItems="center">
            <Stack component="form" noValidate>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                <DatePicker
                  slotProps={{ field: { clearable: true } }}
                  displayWeekNumber
                  label="Date de début"
                  value={absenceStartDate && new Date(absenceStartDate)}
                  onChange={(newValue) => {
                    if (newValue === null) {
                      setAbsenceStartDate(null);
                    } else setAbsenceStartDate(moment(newValue).format("YYYY-MM-DD"));
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  format="dd/MM/yyyy"
                />
              </LocalizationProvider>
            </Stack>
          </Grid>
          <Grid item xs={12} lg={6} display="block" alignItems="center">
            <Stack component="form" noValidate>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
                <DatePicker
                  slotProps={{ field: { clearable: true } }}
                  displayWeekNumber
                  label="Date de fin"
                  value={absenceEndDate && new Date(absenceEndDate)}
                  onChange={(newValue) => {
                    if (newValue === null) {
                      setAbsenceEndDate(null);
                    } else setAbsenceEndDate(moment(newValue).format("YYYY-MM-DD"));
                  }}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                  format="dd/MM/yyyy"
                />
              </LocalizationProvider>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </MDBox>
  );
}
